// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-fade {
  transition: opacity .5s;
}
.toast-fade-slow {
  transition: opacity 2s;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@coreui/react/es/toast/CToast.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".toast-fade {\r\n  transition: opacity .5s;\r\n}\r\n.toast-fade-slow {\r\n  transition: opacity 2s;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
